


































































import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { ISelectingMapping } from "@/models/imports";

@Component
export default class SelectMappingListItem extends Vue {
  // Props

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: null })
  public item!: ISelectingMapping;

  @Prop({ default: null })
  public selectedId!: string | null;

  @Prop({ default: false })
  public isProcessing!: (string | null)[];

  @Prop({ default: false })
  public showMedia!: boolean;

  // Methods

  public onSelect(id) {
    this.$emit("select", id);
  }

  // Computed

  public get showSkeletons() {
    return this.$_.isNull(this.item);
  }

  public get isSelected() {
    return this.isProcessing[this.item.id];
  }
}
